<template>
    <div class="main-content">
        <div class="uk-padding">
            <ul class="uk-breadcrumb">
                <li><router-link to="/blog">Blog</router-link></li>
            </ul>
            <h1 class="uk-align-left">Blog</h1>
            <div class="uk-align-right">
                <router-link :to="{ name: 'EditBlogPost', params: { id: 0 }}" uk-toggle uk-icon="icon: plus; ratio: 2"></router-link>
            </div>
            
            <table class="uk-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Naam</th>
                        <th>Categorie</th>
                        <th>Laatste update</th>
                        <th width="30"></th>
                        <th width="30"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(p, id) in blogposts">
                        <td><span uk-icon="icon: bolt; ratio: 1.2"></span></td>
                        <td>{{p.title}}</td>
                        <td v-if="p.category">{{p.category}}</td>
                        <td v-else-if="p.categories"><span v-for="c in p.categories">{{c}} - </span></td>
                        <td>{{convertDate(p.lastEdit)}}</td>
                        <td>
                            <router-link :to="{ name: 'EditBlogPost', params: { id: id }}" class="uk-link" uk-icon="icon: cog"></router-link>
                        </td>
                        <td>
                            <a class="uk-link" @click.prevent="remove(id)" uk-icon="icon: trash"></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import {db} from '@/CUSTOM/helpers/firebase'
import imagePicker from '@/CORE/modules/MEDIA/imagePicker'
import VueImage from '@/CORE/modules/MEDIA/VueImage'
import Vue from 'vue';
export default {
    name: 'Projects',
    components: {imagePicker, VueImage},
    data () {
        return {
            blogposts: null,
            categories: null,
        }
    },
    created () {
        db.collection('blogposts').onSnapshot((snap) => {
            this.blogposts = {}
            snap.forEach((doc) => {
                this.blogposts[doc.id] = doc.data()
            })
        })
        db.collection('categories').doc('all').get().then(doc => {
            this.categories = doc.data()
        }).catch(error => {
            console.log(error)
        })
    },
    methods: {
        convertDate (timestamp) {
            return moment(timestamp).fromNow();
        },
        remove(key){
            db.collection('blogposts').doc(key).delete()
        }

    }
}
</script>


// WEBPACK FOOTER //
// Overview.vue?e6b426f6